import { message, Modal, Select } from 'antd';
import { useEffect, useState } from 'react';
import { AGENT_STATUS, CALLSTATUS, CALL_DIRECTION, PERMISSION } from 'utils';

import { useLazyGetReasonsOptionsQuery } from 'services/reasons/reasons.api';
import { useToggleScreenRecord } from 'hooks/screen-record';


interface PauseReasonModalProps {
    showPauseReasonModal: boolean;
    setShowPauseReasonModal: (value: boolean) => void;
    toggleAgentStatus: (status: AGENT_STATUS.AGENT_PAUSED | AGENT_STATUS.AGENT_UNPAUSED, reasonId?: number) => void;
    isTogglingStatus: boolean; // Add this prop
    selectedPauseReason: number | undefined;
    setSelectedPauseReason: (value: number | undefined) => void;
}
const PauseReasonModal: React.FC<PauseReasonModalProps> = ({ showPauseReasonModal, setShowPauseReasonModal, toggleAgentStatus, isTogglingStatus, selectedPauseReason, setSelectedPauseReason }) => {

    const { onToggleScreenRecordHandle } = useToggleScreenRecord()

    // Pause‐reason modal state
    const [fetchReasons, { data: reasonsData, isLoading: isLoadingReasons }] = useLazyGetReasonsOptionsQuery();
    useEffect(() => {
        fetchReasons({ pageIndex: 1, pageSize: 100 });

    }, [])

    // In the handleSubmit or confirm function, pass the selectedReason
    const handleConfirm = () => {
        if (selectedPauseReason) {
            toggleAgentStatus(AGENT_STATUS.AGENT_PAUSED, selectedPauseReason);
            setShowPauseReasonModal(false);
            onToggleScreenRecordHandle({
                "isRec": false,
            })
        } else {
            message.warning('Vui lòng chọn lý do tạm dừng');
        }
    };

    return (
        <div className='h-full'>
            {/* Pause‐Reason Modal */}
            <Modal
                title="Chọn lý do bận"
                open={showPauseReasonModal}
                onCancel={() => setShowPauseReasonModal(false)}
                okText="Xác nhận"
                cancelText="Hủy"
                okButtonProps={{ disabled: !selectedPauseReason }}
                onOk={handleConfirm}
            >
                <Select
                    style={{ width: '100%' }}
                    placeholder="Chọn lý do"
                    loading={isLoadingReasons}
                    value={selectedPauseReason}
                    onChange={setSelectedPauseReason}
                    options={reasonsData?.data.rows.map(r => ({
                        label: r.content,
                        value: r.reasonId
                    }))}
                />
            </Modal>
        </div>
    );
}

export default PauseReasonModal;
